__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@vuepic/vue-datepicker", "3.6.8", () => (__webpack_require__.e(3418).then(() => (() => (__webpack_require__(3418))))));
			register("ant-design-vue", "3.2.20", () => (__webpack_require__.e(840).then(() => (() => (__webpack_require__(840))))));
			register("axios", "1.6.7", () => (__webpack_require__.e(9661).then(() => (() => (__webpack_require__(9661))))));
			register("jquery", "3.7.1", () => (__webpack_require__.e(4651).then(() => (() => (__webpack_require__(4651))))));
			register("moment-timezone", "0.5.48", () => (Promise.all([__webpack_require__.e(6302), __webpack_require__.e(9943)]).then(() => (() => (__webpack_require__(6302))))));
			register("moment", "2.30.1", () => (Promise.all([__webpack_require__.e(8666), __webpack_require__.e(6857)]).then(() => (() => (__webpack_require__(9420))))));
			register("phaser", "3.55.2", () => (__webpack_require__.e(4839).then(() => (() => (__webpack_require__(4839))))));
			register("pinia", "2.1.7", () => (() => (__webpack_require__(9150))), 1);
			register("vue-final-modal", "3.4.11", () => (__webpack_require__.e(6592).then(() => (() => (__webpack_require__(6592))))));
			register("vue-i18n", "9.9.1", () => (() => (__webpack_require__(8713))), 1);
			register("vue-router", "4.5.1", () => (() => (__webpack_require__(7069))), 1);
			register("vue", "3.4.19", () => (() => (__webpack_require__(7560))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};